export default {
	resetPasswordResult : null,
    resetPasswordError : null,
}